module.exports = __webpack_public_path__ + "img/page_recargate_slider_02.be61b809.png";